import React from 'react'
import { Column } from 'primereact/column'

const ExpanderColumn = ({ title, expand }) => {
    // Convert expand to appropriate value: keep functions as-is, convert others to boolean
    const expanderValue = typeof expand === 'function' ? expand : !!expand

    return (
        <Column
            expander={expanderValue}
            header={title}
            style={{ width: '8rem' }}
        />
    )
}

export default ExpanderColumn
